import $ from "jquery";
import { isResponsiveMD, isResponsiveSM, isResponsiveXS, } from "./globals/index";

let slideIndex = 1;

class SimpleSlider {

    constructor() {
        this.init();
        this.eventListeners();

        const $self = this;
        $self.removeDsktCollage()
        $(window).resize(function () {
            $self.removeDsktCollage()
        });
    }

    init() {
        this.showElemts(slideIndex);
    }

    changeElement(item) {
        this.showElemts(slideIndex += item);
    }

    showElemts(currentElement) {
        let i;
        const sliderItems = document.getElementsByClassName("slider-item");

        if (currentElement > sliderItems.length) {
            slideIndex = 1
        }
        if (currentElement < 1) {
            slideIndex = sliderItems.length
        }
        for (i = 0; i < sliderItems.length; i++) {
            sliderItems[i].style.display = "none";
        }

        if (sliderItems[slideIndex - 1]) {
            sliderItems[slideIndex - 1].style.display = "block";
            $('.slider-count').text(`${slideIndex} / ${sliderItems.length}`);
        }
    }

    removeDsktCollage() {
        if (isResponsiveSM() || isResponsiveXS() || isResponsiveMD()) {
            if ($(".clf2020-custom-collage").length) {
                $(".clf2020-custom-collage").remove();
            }
        }
    }

    eventListeners() {
        const $self = this;
        $(".left-arrow").click(function (event) {
            event.stopPropagation();
            $self.changeElement(-1)
        });

        $(".right-arrow").click(function (event) {
            event.stopPropagation();
            $self.changeElement(1)
        });
    }
}

export default SimpleSlider;
